import sonidoGeneral from '../../assets/alert.wav';
import sonidoVip from '../../assets/alerta_vip.wav';

/** Tipo de evento del pánico de un equipo VIP. */
export const TIPO_VIP = 'SERVICIO_VIP';

/** true si en la lista de alertas de Operador hay alguna de pánico VIP. */
export const hayVip = (alertas) => (alertas || []).some(d => d && d.tipo
    && (d.tipo.nombre === TIPO_VIP || d.tipo.codigo === 'ALE-0000-0000-0003'));

/**
 * Qué sonido corresponde: con un pánico VIP en la lista suena siempre la sirena VIP (pedido de Roberto 28/10),
 * que no se confunde con el sonido general de las demás alertas. null si no hay alertas.
 */
export const sonidoPara = (alertas) => {
    if (!alertas || alertas.length === 0) return null;
    return hayVip(alertas) ? sonidoVip : sonidoGeneral;
};

/** Reproduce el sonido; el navegador puede bloquearlo hasta que el usuario toque la página. */
export const reproducir = (archivo) => {
    if (!archivo) return;
    try {
        const p = new Audio(archivo).play();
        if (p && p.catch) p.catch(() => { console.log('Audio play blocked'); });
    } catch (e) {
        // un navegador sin audio no puede cortar el aviso visual
    }
};

export { sonidoVip };
